import React from 'react';

import { Block } from '../common/Block.jsx';
import { Builder, EditorContainer } from '../layout/Builder.jsx';
import { default as Image, ImageBlockV1 } from '../common/Image.jsx';
import Layout from '../common/Layout.jsx';
import Name from '../common/Name.jsx';
import Utilities from '../common/Utilities.jsx';

function SliderCellContainer(props) {
    let contentConfig = props.contentConfig;
    if (!contentConfig && props.data && props.data.slideContent) {
        contentConfig = props.data.slideContent;
    }
    if (!contentConfig) {
        contentConfig = {};
    }
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop && contentConfig.desktop.blocks;
    }
    const imageComponentName = props.imageComponentName || Name.Block.Slider.Cell.Image;
    let containerStyle = {};
    Utilities.copyObject(props.style, containerStyle);
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d, blockConfig, parentProps) => {
            const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
            if (!d.type) {
                return blockProps;
            }
            switch (d.type.value) {
                case Name.Block.ButtonV2:
                case Name.Block.ButtonV3: {
                    if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    if (!blockProps.style.width) {
                        blockProps.style.width = '100%';
                    }
                    break;
                }
                case Name.Block.Columns: {
                    if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    if (!blockProps.style.width) {
                        blockProps.style.width = '100%';
                    }
                    if (!blockProps.style.height && d.config && d.config.layout && d.config.layout.minHeight && d.config.layout.minHeight.value && d.config.layout.minHeight.value.length > 0) {
                        blockProps.style.height = `${d.config.layout.minHeight.value}${d.config.layout.minHeight.unit}`;
                    }
                    break;
                }
                case Name.Block.Text: {
                    if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    if (!blockProps.style.width) {
                        blockProps.style.width = '100%';
                    }
                    break;
                }
                case imageComponentName: {
                    if (!parentProps.inLayout && d.config && d.config.block && d.config.block.isCropped) {
                        if (!blockProps.style) {
                            blockProps.style = {};
                        }
                        if (!blockProps.style.height) {
                            blockProps.style.height = '100%';
                        }
                        if (!blockProps.style.width) {
                            blockProps.style.width = '100%';
                        }
                    }
                    break;
                    // const style = { height: '100%', width: '100%' };
                    // if (blockConfig && blockConfig.block && blockConfig.block.isCropped) {
                    //     style.height = '100%';
                    // }
                    // return { style: style };
                }
            }
            return blockProps;
        }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        }
    }
    let className = 'slider__slide carousel__slide';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (!props.builder && !props.data) {
        containerStyle.paddingRight = props.itemSpacing;
        return <div className={className} style={containerStyle} />
    }
    let link;
    if (props.data && props.data.href && props.data.href.length > 0) {
        link = props.data.href;
    } else {
        link = props.link;
    }
    const style = props.style ? { ...props.style } : {};
    style.paddingRight = props.itemSpacing;
    if (props.editor) {
        if (props.parentBlock && props.parentBlock.config && props.parentBlock.config.layout && props.parentBlock.config.layout.height && props.parentBlock.config.layout.height.value && props.parentBlock.config.layout.height.value.length > 0) {
            style.height = `${props.parentBlock.config.layout.height.value}${props.parentBlock.config.layout.height.unit}`;
        } else {
            style.height = '94vh';
        }
    }
    let cellClassName = 'cell--whitelabel carousel__slide--content';
    if (props.type) {
        cellClassName += ` cell--whitelabel--${props.type}`
    }
    const handleBlockProps = (d, _props) => {
        if (!d.type) {
            return;
        }
        switch (d.type.value) {
            case Name.Block.ButtonV2:
            case Name.Block.ButtonV3:
                const blockProps = { type: 'button' };
                if (d.config && d.config.layout && d.config.layout.width && d.config.layout.width.value && d.config.layout.width.value.length > 0) {
                    blockProps.wrapperClassName = 'btn--fw';
                }
                if (!props.builder && (!_props || !_props.inLayout)) {
                    blockProps.containerStyle = { width: '100%' };
                }
                return blockProps;
            case Name.Block.PageTitleV1:
                return { pageData: props.pageData };
            case Name.Block.Text:
                return { style: { width: '100%' } };
            default:
                if (props.blockPropsHandler) {
                    return props.blockPropsHandler(d);
                }
                break;
        }
    }
    const handleMapStyleConfigProp = (configName, propName, propValue, propUnit, style) => {
        switch (propName) {
            case 'alignment':
                switch (propValue) {
                    case 'tl':
                        style.alignItems = 'flex-start';
                        style.justifyContent = 'flex-start';
                        break;
                    case 'tc':
                        style.alignItems = 'center';
                        style.justifyContent = 'flex-start';
                        break;
                    case 'tr':
                        style.alignItems = 'flex-end';
                        style.justifyContent = 'flex-start';
                        break;
                    case 'ml':
                        style.alignItems = 'flex-start';
                        style.justifyContent = 'center';
                        break;
                    case 'mc':
                        style.alignItems = 'center';
                        style.justifyContent = 'center';
                        break;
                    case 'mr':
                        style.alignItems = 'flex-end';
                        style.justifyContent = 'center';
                        break;
                    case 'bl':
                        style.alignItems = 'flex-start';
                        style.justifyContent = 'flex-end';
                        break;
                    case 'bc':
                        style.alignItems = 'center';
                        style.justifyContent = 'flex-end';
                        break;
                    case 'br':
                        style.alignItems = 'flex-end';
                        style.justifyContent = 'flex-end';
                        break;
                }
                return true;
        }
    };
    return (
        <div className={className} style={style}>
            <EditorContainer
                {...props}
                backgroundColor={Layout.backgroundColorV2(props, contentConfig)}
                blockPropsHandler={handleBlockProps}
                blocks={blocks}
                builderBlockPropsHandler={handleBuilderBlockProps}
                className={cellClassName}
                containerProps={contentConfig.desktop && contentConfig.desktop.page}
                inCell={true}
                link={link}
                newWindow={props.data && props.data.newWindow}
                style={containerStyle}
                onContainerProps={props.onPageProps}
                onMapStyleConfigProp={handleMapStyleConfigProp} />
        </div>
    );
}

// region IMAGE

function SlideImageComponent(props) {
    const imageProps = {};
    let isCropped = false;
    if (props.blockConfig && props.blockConfig.block) {
        isCropped = props.blockConfig.block.isCropped;
        if (!isCropped) {
            imageProps.altText = props.blockConfig.block.altText;
        }
        if (props.blockConfig.block.image && props.blockConfig.block.image.id && props.blockConfig.block.image.extension) {
            const imageData = props.blockConfig.block.image;
            imageProps.image = imageData;
            imageProps.imageId = imageData.id;
            imageProps.transform = isCropped ? 'c_fill' : 'c_fit';
        }
    }
    let imageId = imageProps.imageId || '';
    if (isCropped) {
        imageId += '-cropped';
    }
    const style = {};
    Utilities.copyObject(props.style, style);
    style.maxHeight = '100%';
    return (
        <ImageBlockV1.Component
            {...props}
            {...imageProps}
            containerStyle={{ justifyContent: 'center', overflow: 'hidden', position: 'relative' }}
            imageId={imageId}
            inCell={true}
            style={style} />
    );
}
const SlideImage = { Component: SlideImageComponent };

export { SliderCellContainer, SlideImage }